import { useState, useEffect } from 'react'
import { ref, getDownloadURL } from 'firebase/storage'
import { storage } from '../config/firebase'
import localData from '../../data/kidase.json'

const USE_LOCAL_DATA = import.meta.env.DEV

// Opening prayer is shown separately on the home page, not as a lesson
const OPENING_PRAYER_ID = 'CD-1-Track01-Slide_6'

function filterOpeningPrayer(categories) {
  return categories.map(cat => ({
    ...cat,
    chants: cat.chants.filter(c => c.id !== OPENING_PRAYER_ID)
  }))
}

export function useLiturgyData() {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true)

        if (USE_LOCAL_DATA) {
          // Use local JSON in development
          setCategories(filterOpeningPrayer(localData.categories || []))
        } else {
          // Fetch kidase.json from Firebase Storage in production
          const jsonRef = ref(storage, 'data/kidase.json')
          const url = await getDownloadURL(jsonRef)
          const response = await fetch(url)
          const data = await response.json()
          setCategories(filterOpeningPrayer(data.categories || []))
        }
      } catch (err) {
        console.error('Error fetching liturgy data:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return { categories, loading, error }
}
